import apiFetch from '../apiFetch'

export default function (conditionNoDocumentalId, token, conditionNoDocumental) {
  return apiFetch({ endPoint: `conditionNoDocumental/${conditionNoDocumentalId}`, method: 'PUT', body: conditionNoDocumental, token: token })
}
